module.exports = __webpack_public_path__ + "media/flags/cg-242ffce6.svg";